import { h } from 'preact';
import { useEffect } from 'preact/hooks';
import { ShippingProgressBar } from './ShippingProgressBar';
import { CartProductList } from './CartProductList';
import { CartDrawerTotal } from './CartDrawerTotal';
import { CartRecommendations } from './CartRecommendations';
import { useShopware } from '../shopware/ShopwareContext';

interface CartProps {
  onClose?: () => void;
}

export const Cart = ({ onClose }: CartProps) => {
  const { cart, refreshCart } = useShopware();

  // Fetch cart on mount only if it doesn't exist yet
  useEffect(() => {
    if (!cart) {
      refreshCart();
    }
  }, [cart, refreshCart]);

  if (!cart) {
    return <p className="text-center">Lade Warenkorb...</p>;
  }

  if (!cart.lineItems || cart.lineItems.length === 0) {
    return <p className="text-center">Dein Warenkorb ist leer.</p>;
  }

  return (
    <>
      <ShippingProgressBar />
      <CartProductList />
      <div className="d-none d-md-block d-lg-none">
        <CartDrawerTotal onClose={onClose} />
      </div>
      <CartRecommendations />
    </>
  );
};
